import React from 'react';

function GithubSvg({ className }) {
  return (
    <svg
      className={className}
      width="84"
      height="58"
      viewBox="0 0 84 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.2821 74.2583C11.7949 80.1044 11.7949 64.5147 4 62.566M58.5641 85.9506V70.8675C58.7103 69.0091 58.4592 67.1408 57.8275 65.3869C57.1959 63.633 56.1981 62.0337 54.9005 60.6952C67.1385 59.3311 80 54.6931 80 33.4131C79.999 27.9716 77.9059 22.7388 74.1538 18.7978C75.9305 14.0371 75.8049 8.77491 73.8031 4.10442C73.8031 4.10442 69.2041 2.74032 58.5641 9.87263C49.6312 7.45163 40.2149 7.45163 31.2821 9.87263C20.6421 2.74032 16.0431 4.10442 16.0431 4.10442C14.0413 8.77491 13.9156 14.0371 15.6923 18.7978C11.9123 22.7681 9.81701 28.0482 9.84615 33.5301C9.84615 54.6542 22.7077 59.2921 34.9456 60.8121C33.6634 62.1371 32.6745 63.7173 32.0433 65.4498C31.412 67.1822 31.1527 69.0282 31.2821 70.8675V85.9506"
        stroke="#F7F6F6"
        strokeWidth="7.79487"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default GithubSvg;
